/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conn_Clear_ConfirmInputs */

const cs_ebr_conn_clear_confirm = /** @type {(inputs: Ebr_Conn_Clear_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opravdu odpojit eBránu? Importy přestanou fungovat, dokud adresu znovu nevložíte.`)
};

const en_ebr_conn_clear_confirm = /** @type {(inputs: Ebr_Conn_Clear_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnect eBrána? Imports stop working until you add the address again.`)
};

/**
* | output |
* | --- |
* | "Disconnect eBrána? Imports stop working until you add the address again." |
*
* @param {Ebr_Conn_Clear_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conn_clear_confirm = /** @type {((inputs?: Ebr_Conn_Clear_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conn_Clear_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conn_clear_confirm(inputs)
	return cs_ebr_conn_clear_confirm(inputs)
});